export default __webpack_public_path__ + "static/media/Template1-dark.f3d9c0df.png";